module.exports = __webpack_public_path__ + "static/media/no-avatar.2f6a2aa3.png";